{
  "$schema": "http://json-schema.org/draft-07/schema",
  "$id": "DeletedEventSchemaDefinitions",
  "definitions": {
    "DeletedEventSchema": {
      "type": "object",
      "additionalProperties": false,
      "required": ["id"],
      "properties": {
        "id": {
          "type": "string",
          "format": "uuid"
        }
      }
    }
  }
}
